'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Radio = require('./../Style/Radio');

var _Radio2 = _interopRequireDefault(_Radio);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BinaryRadioBox = function (_Component) {
  _inherits(BinaryRadioBox, _Component);

  function BinaryRadioBox(props) {
    _classCallCheck(this, BinaryRadioBox);

    var _this = _possibleConstructorReturn(this, (BinaryRadioBox.__proto__ || Object.getPrototypeOf(BinaryRadioBox)).call(this, props));

    var filter = _this.props.filter;

    _this.styles = require('./BinaryRadioBox.scss');
    _this.state = {
      filter: filter,
      filter_data: null,
      search_value: '',
      data: []
    };
    _this.state.data = _this.getData(50);
    return _this;
  }

  _createClass(BinaryRadioBox, [{
    key: 'getData',
    value: function getData(max) {
      var _this2 = this;

      var _props = this.props,
          filter = _props.filter,
          highlightCases = _props.highlightCases;

      var RADIOBOX_RENDER = [];
      var style = {};
      var count = 0;

      Object.keys(filter.children).forEach(function (key) {
        if (count < max) {
          var id = Math.random();
          if (_this2.state.search_value.trim() === '' || filter.children[key].name.toLowerCase().indexOf(_this2.state.search_value.trim().toLowerCase()) !== -1) {
            if (highlightCases.indexOf(filter.children[key].id) !== -1) {
              style.weight = 900;style.color = '#6090C3';
            } else {
              style = {};
            }
            RADIOBOX_RENDER.push(_react2.default.createElement(
              _Radio2.default,
              null,
              _react2.default.createElement('input', {
                defaultChecked: filter.children[key].check ? filter.children[key].check : false,
                key: id,
                type: 'radio',
                id: filter.name.toLowerCase().split(' ').join('_') + '_' + filter.children[key].id,
                name: filter.name.toLowerCase().replace(/\s/g, '_'),
                onChange: _this2.handleRadioBoxClick.bind(_this2, filter.children[key]),
                value: filter.children[key].id
              }),
              _react2.default.createElement(
                'label',
                { htmlFor: filter.name.toLowerCase().split(' ').join('_') + '_' + filter.children[key].id },
                filter.children[key].name
              )
            ));
          }
        }
        count = count + 1;
      });
      return RADIOBOX_RENDER;
    }
  }, {
    key: 'getSearchInput',
    value: function getSearchInput() {
      var filter = this.props.filter;

      return _react2.default.createElement(
        'div',
        { className: this.styles.binary_filter_search },
        _react2.default.createElement('i', { className: 'fa fa-search' }),
        _react2.default.createElement('input', {
          onChange: this.search.bind(this),
          type: 'text',
          placeholder: 'Search',
          ref: 'search',
          id: 'binary_checkbox_search_' + filter.name,
          maxLength: 80,
          value: this.state.search_value
        })
      );
    }
  }, {
    key: 'search',
    value: function search(event) {
      var _this3 = this;

      this.setState({
        search_value: event.target.value
      }, function () {
        _this3.setState({
          data: _this3.getData(3000)
        });
      });
    }
  }, {
    key: 'handleRadioBoxClick',
    value: function handleRadioBoxClick(filter) {
      var _this4 = this;

      var handleChange = this.props.handleChange;

      this.setState({
        filter_data: filter
      }, function () {
        handleChange(_this4.state.filter_data);
      });
    }
  }, {
    key: 'showTheRest',
    value: function showTheRest() {
      var data = this.getData(3000);
      this.setState({ data: data });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          filter = _props2.filter,
          search = _props2.search,
          customClassName = _props2.customClassName;

      var styles = require('./BinaryRadioBox.scss');

      return _react2.default.createElement(
        'div',
        null,
        search && this.getSearchInput(),
        _react2.default.createElement(
          'div',
          { key: filter.name, className: styles.binary_radiobox_container + ' ' + customClassName },
          this.state.data,
          this.state.search_value.length === 0 && Object.keys(this.state.filter.children).length > 50 && this.state.data.length < 51 && _react2.default.createElement(
            'p',
            { style: { color: '#6090C3', margin: '10px', cursor: 'pointer' }, onClick: this.showTheRest.bind(this) },
            'Show More'
          ),
          this.state.data.length === 0 && _react2.default.createElement(
            'p',
            { id: filter.name ? filter.name.split(' ').join('_').toLowerCase() + '_noresult' : 'noresult' },
            'No Results Found!'
          )
        )
      );
    }
  }]);

  return BinaryRadioBox;
}(_react.Component);

BinaryRadioBox.propTypes = {
  filter: _propTypes2.default.object.isRequired,
  search: _propTypes2.default.bool,
  highlightCases: _propTypes2.default.array,
  handleChange: _propTypes2.default.func.isRequired,
  customClassName: _propTypes2.default.string
};
BinaryRadioBox.defaultProps = {
  highlightCases: [],
  search: false
};
exports.default = BinaryRadioBox;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/BinaryRadioBox/BinaryRadioBox.js
// module id = 2170
// module chunks = 1